import styled from 'styled-components';
import { white } from 'styles/Colors';

export const Text = styled.div`
  color: ${white};
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 21px;
  width: 100%;
  text-align: center;
  padding: 8px 0;
`;
